import NotificationService from '../services/notification-service';
import { Dispatch } from 'redux';
import { refetchProfile } from './profile';
import { chatNotification } from '../reducers/chats/actions';

export enum NotificationActionTypes {
    FCM_TOKEN_GENERATED = 'FCM_TOKEN_GENERATED',
    NOTIFICATONS_GET_SUCCESS = 'NOTIFICATONS_GET_SUCCESS',
    NOTIFICATONS_MARK_AS_READ = 'NOTIFICATONS_MARK_AS_READ',
    NOTIFICATONS_MARK_ALL_AS_READ = 'NOTIFICATONS_MARK_ALL_AS_READ'
}

export function getNotifications() {
    return async (dispatch: any) => {
        try {    
            const response = await NotificationService.getAll();
            dispatch({ type: NotificationActionTypes.NOTIFICATONS_GET_SUCCESS, data: response.data });
        } catch( error ) {
        }
    }
}

export function markAsRead(id: string) {
    return async (dispatch: any) => {
        try {    
            await NotificationService.markAsRead(id);
            dispatch({ type: NotificationActionTypes.NOTIFICATONS_MARK_AS_READ, id });
        } catch( error ) {            
        }
    }
}

export function markAllAsRead() {
    return async (dispatch: any) => {
        try {    
            const response = await NotificationService.markAllAsRead();
            const { ids } = response.data;
            dispatch({ type: NotificationActionTypes.NOTIFICATONS_MARK_ALL_AS_READ, ids });
        } catch( error ) {            
        }
    }
}

export function handleMessage(data: any) {
    return (dispatch: Dispatch) => {
        switch(data.service) {
            case 'profile': return dispatch<any>(refetchProfile(data.updated_at));
            //case 'appointment': return dispatch<any>(appointmentNotification(data));
            case 'chat': return dispatch<any>(chatNotification(data));
            //case 'discussion': return dispatch<any>(discussionNotification(data));
        }
    }
}